import { HTTP_STATUSES } from "@miplatform/constants";
import {
  API_VERSION,
  SUBSCRIPTION_SERVICE,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_SUBSCRIPTIONS = `${SUBSCRIPTION_SERVICE}/subscriptions`;

export const subscriptions = {
  get: async (id) => {
    const options = await apiOptions({
      url: `${API_SUBSCRIPTIONS}/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  getAll: async () => {
    const options = await apiOptions({
      url: API_SUBSCRIPTIONS,
      method: "get",
    });
    return apiRequest(options);
  },
  validate: async (domain) => {
    const options = await apiOptions({
      url: `${API_SUBSCRIPTIONS}/${domain}/validate`,
      method: "get",
    });
    const response = await apiRequest(options);
    if (response.status === HTTP_STATUSES.OK) {
      return response.data;
    }
    return null;
  },
  updateSso: async (companyName, data) => {
    const options = await apiOptions({
      url: `${API_SUBSCRIPTIONS}/${companyName}/updatesso`,
      method: "post",
      data,
    });
    const response = await apiRequest(options);
    if (response.status === HTTP_STATUSES.ACCEPTED) {
      return response.data;
    }
    return null;
  },
  createNewTenant: async (companyName) => {
    const options = await apiOptions({
      url: `${API_SUBSCRIPTIONS}/${companyName}/newtenant`,
      method: "post",
    });
    const response = await apiRequest(options);
    if (response.status === HTTP_STATUSES.ACCEPTED) {
      return response.data;
    }
    return null;
  },
  /**
   * Update a tenant
   * @param {Object} params
   * @param {string} params.id - required - tenant id
   * @param {Object} params.data - The data to update
   * @param {string} params.data.modifiedOn required - The modifiedOn value of the tenant
   * @param {?string} params.data.name - The name of the tenant
   * @param {Object} params.toastMessageConfig - The config for the toast message
   * @returns a Promise
   */
  updateTenant: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_SUBSCRIPTIONS}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
